import React from 'react';
import {
  colorTokenMap,
  Divider,
  GDSBorderWidthToken,
  GDSColorToken,
  borderWidthTokenMap,
} from '@leagueplatform/genesis-core';
import {
  type MasonryEngineNode,
  type MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';

export type MasonryDividerNodeProperties = {
  color?: GDSColorToken;
  orientation: 'horizontal' | 'vertical';
  thickness?: GDSBorderWidthToken;
};

export type MasonryDividerNode = MasonryEngineNode<
  'divider',
  MasonryDividerNodeProperties,
  {}
>;

export type MasonryDividerRendererProps =
  MasonryEngineNodeRendererProps<MasonryDividerNode>;

export const MasonryDividerRenderer = ({
  orientation,
  color = 'onSurfaceBorderSubdued',
  thickness = 'thin',
  locatorId,
  css,
  rootElementRef,
}: MasonryDividerRendererProps) => {
  const borderColor = colorTokenMap[color] ?? color;
  const borderWidth = borderWidthTokenMap[thickness] ?? thickness;

  return (
    <Divider
      ref={rootElementRef}
      data-testid={locatorId}
      orientation={orientation}
      css={{ borderColor, borderWidth: `0px 0px ${borderWidth}`, ...css }}
    />
  );
};
